/*
 * Delete-category.ts
 * Description: Includes the declaration
 * of the function for deleting a category
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Delete a certain category
 *
 * @return {Object} Promise - deleted category
 * @param {String} slug - id of a restaurant
 * @param {Number} categoryId - id of a the category
 */
export function deleteCategory(slug: string, categoryId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/menu-categories/' + categoryId,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
